<template>
  <div :class="classes">
    <div class="wf-flex wf-justify-between wf-items-center">
      <img class="wf-w-48" src="https://storage.googleapis.com/wfs/images/logo-01.png" alt="">  
      <button @click.prevent="menuVisible = true" class="focus:wf-outline-none"><i class="fas fa-bars wf-text-xl"></i></button>
    </div>
    <div v-show="menuVisible" class="wf-absolute wf-z-100 wf-w-full wf-top-0 wf-left-0 wf-h-screen wf-flex-col wf-flex wf-bg-white">
      <div class="wf-py-6 wf-px-2 wf-flex wf-justify-between wf-container wf-mx-auto">
        <img class="wf-w-48" src="https://storage.googleapis.com/wfs/images/logo-01.png" alt="">
        <button @click.prevent="menuVisible = false" class="focus:wf-outline-none"><i class="fas fa-times wf-text-2xl"></i></button>
      </div>
      <div v-if="navLinkSelected === null" class="wf-flex wf-flex-1 wf-items-center wf-justify-center">
        <ul class="wf-text-center wf-space-y-12">
          <li :class="navLinkClasses" :style="navLinkStyles" v-for="(navLink, index) in navLinks" :key="index">
            <div v-if="navLink.children.length" class="wf-flex wf-flex-col">
              <a  href="#" @click.prevent="navLinkSelected =  index" v-text="navLink.text"></a>
              <span class="wf-inline-block wf-mt-1 wf-text-xxs wf-text-gray-600">(menu)</span>
            </div>
            <span v-else v-text="navLink.text"></span>
          </li>
          <li :class="ctaClasses" :style="ctaStyles" v-show="hasCta">
            <div v-text="ctaText"></div>
          </li>
        </ul>
      </div>
      <div v-if="navLinkSelected !== null && childSelected === null" class="wf-flex wf-flex-1 wf-items-center wf-justify-center">
        <ul class="wf-text-center wf-space-y-12">
          <li>
          <a href="#" class="wf-text-gray-600 wf-font-semibold wf-text-sm" @click.prevent="navLinkSelected = null">
            <i class="fas fa-arrow-left wf-text-xs wf-mr-2"></i>back
          </a>
          </li>
          <li :class="navLinkClasses" :style="navLinkStyles" v-for="(childLink, childIndex) in navLinks[navLinkSelected].children" :key="childIndex">
            <div v-if="childLink.children.length" class="wf-flex wf-flex-col">
              <a  href="#" @click.prevent="childSelected =  childIndex" v-text="childLink.text"></a>
              <span class="wf-inline-block wf-mt-1 wf-text-xxs wf-text-gray-600">(menu)</span>
            </div>
            <span v-else v-text="childLink.text"></span>
          </li>
        </ul>
      </div>
      <div v-if="navLinkSelected !== null && childSelected !== null"  class="wf-flex wf-flex-1 wf-items-center wf-justify-center">
        <ul class="wf-text-center wf-space-y-12">
          <li>
            <a href="#" class="wf-text-gray-600 wf-font-semibold wf-text-sm" @click.prevent="childSelected = null">
              <i class="fas fa-arrow-left wf-text-xs wf-mr-2"></i>back
            </a>
          </li>
          <li :class="navLinkClasses" :style="navLinkStyles" v-for="(grandChildLink, grandChildIndex) in navLinks[navLinkSelected].children[childSelected].children" :key="grandChildIndex">
            <span v-text="grandChildLink.text"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      ctaText: {
        type: String,
        required: true
      },
      hasCta: {
        type: Boolean,
        required: true
      },
      ctaClasses: {
        type: [String, Array],
        required: true,
      },
      ctaStyles: {
        type: [String, Object],
        required: true,
      },
      containerNavLinkClasses: {
        type: [String, Array],
        required: true,
      },
      navLinkClasses: {
        type: [String, Array],
        required: true,
      },
      navLinkStyles: {
        type: [String, Object],
        required: true,
      },
      classes: {
        type: Array,
        required: true,
      },
      logo: {
        type: String,
        required: true,
      },
      navLinks: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        menuVisible: false,
        childSelected: null,
        navLinkSelected: null
      }
    },

    watch: {
      menuVisible(value) {
        if (! value) {
          return document.body.style.removeProperty('overflow')
        }
        document.body.style.setProperty('overflow', 'hidden')
      }
    },
  }
</script>